<template>
  <div class="form_font">
    <b-container class="inner_form_font">
      <b-row>
        <b-col class="content_form_font">
          <b-form-input v-model="nom" placeholder="Nom de la police"></b-form-input>
          <p>Importer une police au format .ttf</p>
          <input type="file" @change="onFileChange" />
          <b-button @click="saveFont">Sauvegarder</b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "HelloWorld",

  data() {
    return {
      nom: "",
      url: "",
    };
  },
  methods: {
    saveFont() {
      var data = new FormData();
      var _this = this;

      data.append("nom", this.nom);
      data.append("url", this.url);
      data.append("action", "save");
      axios.post("https://sportips.fr/plateformeResultats/addFont.php", data).then(function (response) {
        console.log(response.data);
      });
    },
    onFileChange() {
      var data = new FormData();
      var _this = this;

      data.append("image", event.target.files[0], event.target.files[0].name);
      data.append("action", "import");
      axios.post("https://sportips.fr/plateformeResultats/addFont.php", data).then(function (response) {
        console.log(response.data);
        if (response.data.length > 0) {
          _this.url = "https://sportips.fr/plateformeResultats/fonts/" + response.data;
        }
      });
    },
  },
  created() {},
};
</script>
<style>
.container-list-epreuve {
  margin-bottom: 20px;
  border: 1px solid #bbbbbb;
  padding: 10px;
  min-height: 250px;
}
.form_font {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
}
.inner_form_font {
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: #bbbbbb;
  border: 1px solid #000;
}
.content_form_font {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/ImportFont.vue